"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.HEADER_HEIGHT=exports.DASH_SYMBOL=void 0;// eslint-disable-next-line import/prefer-default-export
var HEADER_HEIGHT="60px";exports.HEADER_HEIGHT=HEADER_HEIGHT;var DASH_SYMBOL="\u2013";// "en dash" U+2013
exports.DASH_SYMBOL=DASH_SYMBOL;